import { createFilterSet } from './create'
import { updateFilterSet } from './update'

export const filterSets = {
  create: createFilterSet,
  update: updateFilterSet,
}
